import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

import { scrubBreadcrumbData, scrubTelemetryEvent, telemetrySafeText, telemetrySafeUrl } from './lib/telemetryUrl';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  // Replays are kept for error sessions only: the reserved replay quota ran to 80% in
  // two weeks at 0.1 and would be spent before a large invite round.
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
  // GDPR review 19.10.2026: codes that open a page without signing in, and the sign-in link's
  // email and one-time code, never leave the browser in an address (lib/telemetryUrl).
  beforeSend: (event) => scrubTelemetryEvent(event),
  beforeSendTransaction: (event) => scrubTelemetryEvent(event),
  beforeBreadcrumb: (breadcrumb) => {
    scrubBreadcrumbData(breadcrumb.data);
    return breadcrumb;
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      beforeAddRecordingEvent: (recordingEvent) => {
        const data = (recordingEvent as { data?: { payload?: { href?: unknown; description?: unknown } } }).data;
        if (typeof data?.payload?.href === 'string') data.payload.href = telemetrySafeUrl(data.payload.href);
        // Network and navigation entries name their address in the description.
        if (typeof data?.payload?.description === 'string') data.payload.description = telemetrySafeText(data.payload.description);
        return recordingEvent;
      },
    }),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
});
